import Share from '@/images/Share.svg';
import { LibraryItem, LibraryItemStatus } from '@d-id/types';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { styled } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { ListItemIcon, ListItemText } from './components';

const RightArrow = styled(KeyboardArrowRightIcon)`
    position: absolute;
    right: 4px;
    height: 1.8rem;
    width: 1.8rem;
`;

interface Props {
    video: LibraryItem;
}

export const ShareMenuItem = ({ video }: Props) => {
    if (video!.status !== LibraryItemStatus.Done) {
        return null;
    }

    return (
        <MenuItem>
            <ListItemIcon>
                <img src={Share} />
            </ListItemIcon>
            <ListItemText>Share</ListItemText>
            <RightArrow />
        </MenuItem>
    );
};
